import { Typography } from 'antd';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import SupplierProductGrid from './SupplierProductGrid';
import ProductItemManagementSection from './ProductItemManagementSection';
import SupplierProductListAction from './SupplierProductListAction';
import SupplierPermission from './SupplierPermission';
import Messages from 'i18n/messages/supplier-manager';
import QaSpecTemplateManagementSupplier from '../../qa-spec-template-management/QaSpecTemplateManagementSupplier';
// existing QaSpecTemplateManagement is still available if other pages rely on it, but
// in this setting section we use the supplier-specific copy which can emit a payload.
const { Text } = Typography;

const SupplierManagerSettingSection = (props) => {
  const {
    brandData,
    productData,
    supplierPermissions,
    selectedEntityLevel,
    isProduct,
    isProductDetail,
    handleAddEntityData,
    handleRemoveEntityData,
    handleUpdateSelectedLevel,
    handleUpdateSupplierPermission,
    handleResetAll,
    newParam,
    handleContactSelect,
    selectedSupplier,
    // handler that will receive qa spec payload from the child component
    handleQaSpecPayload,
    // initial QA spec settings loaded by parent
    initialQaSpecSettings,
  } = props;

  const intl = useIntl();

  return (
    <>
      <ProductItemManagementSection>
        <SupplierPermission
          supplierPermissions={supplierPermissions}
          handleUpdateSupplierPermission={handleUpdateSupplierPermission}
          newParam={newParam}
          handleContactSelect={handleContactSelect}
        />

        {/*  QA Spec Template Management Section */}
        <QaSpecTemplateManagementSupplier
          memberInfo={selectedSupplier}
          supplierId={selectedSupplier?.id || newParam}
          hasPermissionEdit={true}
          mode="supplier"
          initialSettings={initialQaSpecSettings}
          onSettingsChange={handleQaSpecPayload} />

        {!isProductDetail && (
          // search product and open dialog
          <div className='supplier-management-modal__select-product'>
            <SupplierProductListAction
              brandData={brandData}
              productData={productData}
              isProduct={isProduct}
              selectedEntityLevel={selectedEntityLevel}
              handleAddEntityData={handleAddEntityData}
              handleRemoveEntityData={handleRemoveEntityData}
              handleResetAll={handleResetAll}
              newParam={newParam}
              handleContactSelect={handleContactSelect}
            />

            <div className='supplier-management-modal__select-product-list'>
              <Text strong level={5} style={{ padding: '8px 0px' }}>
                {intl.formatMessage(
                  Messages.selectEntityLabel.productSelectedTitle
                )}
              </Text>
              <SupplierProductGrid
                productData={productData}
                selectedEntityLevel={selectedEntityLevel}
                handleUpdateSelectedLevel={handleUpdateSelectedLevel}
              />
            </div>
          </div>
        )}
      </ProductItemManagementSection>
    </>
  );
};

SupplierManagerSettingSection.propTypes = {
  brandData: PropTypes.array,
  productData: PropTypes.array,
  supplierPermissions: PropTypes.array,
  selectedEntityLevel: PropTypes.any,
  isProduct: PropTypes.bool,
  isProductDetail: PropTypes.bool,
  handleAddEntityData: PropTypes.func,
  handleRemoveEntityData: PropTypes.func,
  handleUpdateSelectedLevel: PropTypes.func,
  handleUpdateSupplierPermission: PropTypes.func,
  handleResetAll: PropTypes.func,
  newParam: PropTypes.any,
  handleContactSelect: PropTypes.func,
  selectedSupplier: PropTypes.object,
  handleQaSpecPayload: PropTypes.func,
  initialQaSpecSettings: PropTypes.object,
};

export default SupplierManagerSettingSection;
